import { render } from "./VideoPage.vue?vue&type=template&id=5f5271fb"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"

import "./VideoPage.vue?vue&type=style&index=0&id=5f5271fb&lang=scss"

import exportComponent from "/home/runner/work/e-wallet-fe/e-wallet-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__